<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <!-- HEADER -->
      <div class="modal-header">
        <h2>Thêm đơn hàng</h2>
        <button @click="$emit('close')">✖</button>
      </div>

      <!-- TAB -->
      <div class="tabs">
        <button :class="{ active: tab === 'sale' }" @click="tab = 'sale'">
          🛒 Bán hàng
        </button>
        <button :class="{ active: tab === 'repair' }" @click="tab = 'repair'">
          🔧 Sửa chữa
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <!-- TAB: BÁN HÀNG -->
        <div v-if="tab === 'sale'">
          <!-- Chọn khách -->
          <div class="form-group">
            <label>Khách hàng</label>
            <div class="customer-search" ref="wrapper">
              <input
                type="text"
                v-model="keyword"
                @input="handleInput"
                @keydown.enter.prevent="searchCustomers"
                placeholder="Nhập tên hoặc sdt khách hàng..."
              />

              <button
                v-if="keyword"
                @click="clearCustomerSelection"
                class="clear-btn"
                type="button"
              >
                <i class="fa fa-times"></i>
              </button>
              <div v-if="showDropdownCustomer" class="dropdown-customer">
                <div v-if="loading">
                  <i class="fa fa-spinner fa-spin loader-icon"></i>
                  <span>Đang tìm...</span>
                </div>

                <div
                  v-for="(customer, index) in customers"
                  :key="customer.id"
                  :class="['dropdown-item', { active: index === activeIndex }]"
                  @click="selectCustomer(customer)"
                >
                  <strong style="display: grid"
                    >{{ customer.ten_khach_hang }}
                    <span style="text-align: left"
                      >Mã:{{ customer.ma_khach_hang }}</span
                    >
                  </strong>
                  <span>{{ customer.dien_thoai }}</span>
                </div>
                <div
                  v-if="!loading && keyword && !customers.length"
                  class="dropdown-item create"
                  @click="createCustomer"
                >
                  ➕ Tạo khách hàng: "{{ keyword }}"
                </div>
              </div>
            </div>
          </div>

          <!-- Thêm sản phẩm -->
          <div class="form-group product-search">
            <label>Sản phẩm</label>
            <input
              type="text"
              v-model="productInput"
              @keyup.enter="searchProducts"
              placeholder="Nhập tên SP + Enter"
              @input="handleInputProduct"
              :disabled="loading"
            />

            <button
              v-if="productInput"
              @click="clearProductSelection"
              class="clear-btn"
              type="button"
            >
              <i class="fa fa-times"></i>
            </button>
            <div v-if="showDropdownProduct" class="dropdown-product">
              <div v-if="loading">
                <i class="fa fa-spinner fa-spin loader-icon"></i>
                <span>Đang tìm...</span>
              </div>
              <div
                v-for="(product, index) in products"
                :key="product.id"
                :class="['dropdown-item', { active: index === activeIndex }]"
                @click="selectProduct(product)"
              >
                <strong style="display: grid"
                  >{{ product.ten_hang }}
                  <span style="text-align: left">Mã:{{ product.ma_hang }}</span>
                  <span style="text-align: left">
                    Imei: {{ product.serial_imei }}</span
                  >
                </strong>
                <span>{{ formatCurrency(product.gia_ban) }}</span>
              </div>
            </div>
          </div>

          <!-- Danh sách SP -->
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Tên SP</th>
                <th>SL</th>
                <th>Giá</th>
                <th>Thành tiền</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in sale.items" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>
                  <input type="number" v-model="item.quantity" />
                </td>
                <td>
                  <input type="number" v-model="item.price" />
                </td>
                <td>{{ formatCurrency(item.quantity * item.price) }}</td>
                <td>
                  <button @click="removeItem(index)">❌</button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="sub-total">
            Tạm tính: <strong>{{ formatCurrency(subTotal) }}</strong>
          </div>
          <div class="discount-wrapper" ref="discountRef">
            <div class="discount" @click="toggleDiscount">
              Giảm giá: <strong>{{ formatCurrency(discountSale) }}</strong>
            </div>

            <!-- POPUP -->
            <div v-if="showDiscountInput" class="discount-popup">
              <input
                v-model="discountDisplay"
                @keydown.enter="applyDiscount"
                @blur="applyDiscount"
                placeholder="Nhập số tiền giảm"
                autofocus
              />
            </div>
          </div>
          <!-- Tổng -->
          <div class="total">
            Tổng tiền hàng: <strong>{{ formatCurrency(totalSale) }}</strong>
          </div>
          <div class="total">
            Khách thanh toán: <strong>{{ formatCurrency(totalSale) }}</strong>
          </div>
        </div>

        <!-- TAB: SỬA CHỮA -->
        <div v-if="tab === 'repair'">
          <div class="form-group">
            <label>Khách hàng</label>
            <div class="customer-search" ref="wrapper">
              <input
                type="text"
                v-model="keyword"
                @input="handleInput"
                placeholder="Nhập tên hoặc sdt khách hàng..."
              />
              <button
                v-if="keyword"
                @click="clearCustomerSelection"
                class="clear-btn"
                type="button"
              >
                <i class="fa fa-times"></i>
              </button>
              <div v-if="showDropdownCustomer" class="dropdown">
                <div
                  v-for="(customer, index) in customers"
                  :key="customer.id"
                  :class="['dropdown-item', { active: index === activeIndex }]"
                  @click="selectCustomer(customer)"
                >
                  <strong>{{ customer.ten_khach_hang }}</strong>
                  <span>{{ customer.dien_thoai }}</span>
                </div>
                <div
                  v-if="!loading && keyword && !customers.length"
                  class="dropdown-item create"
                  @click="createCustomer"
                >
                  ➕ Tạo khách hàng: "{{ keyword }}"
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Thiết bị</label>
            <input v-model="repair.device_name" placeholder="VD: iPhone 11" />
          </div>

          <div class="form-group">
            <label>Lỗi</label>
            <textarea v-model="repair.issue_description"></textarea>
          </div>

          <div class="form-group">
            <label>Chi phí</label>
            <input type="number" v-model="repair.cost" />
          </div>
          <div class="form-group">
            <label>Thời gian bảo hành</label>
            <input
              type="text"
              v-model="repair.warranty_period"
              placeholder="VD: 6 tháng"
            />
          </div>

          <div class="total">
            Tổng: <strong>{{ formatCurrency(repair.cost) }}</strong>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn-save" @click="submitOrder">Lưu</button>
        <button @click="$emit('close')">Huỷ</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { adminApi, productApi } from "@/services/api";
import { formatCurrency, parseCurrency } from "@/utils/helpers";
import { ref, computed } from "vue";

const emit = defineEmits(["close", "created"]);
const loading = ref(false);
const toast = useToast();
const tab = ref("sale");
const customers = ref([]);
const products = ref([]);
const cache = new Map();
let timeout = null;
const keyword = ref("");
const showDropdownCustomer = ref(false);
const showDropdownProduct = ref(false);
const activeIndex = ref(-1);
const sale = ref({
  customer_id: null,
  customer_name: "",
  items: [],
});

const showDiscountInput = ref(false);

const productInput = ref("");

// const addProduct = () => {
//   if (!productInput.value) return;

//   sale.value.items.push({
//     name: productInput.value,
//     quantity: 1,
//     price: 0,
//   });

//   productInput.value = "";
// };

const removeItem = (index) => {
  sale.value.items.splice(index, 1);
};
const discountSale = ref(0);
const discountRef = ref(null);
const discountDisplay = computed({
  get() {
    return formatCurrency(discountSale.value);
  },
  set(value) {
    discountSale.value = parseCurrency(value);
  },
});

const applyDiscount = () => {
  showDiscountInput.value = false;
};
const subTotal = computed(() =>
  sale.value.items.reduce((sum, i) => sum + i.quantity * i.price, 0),
);
const totalSale = computed(() => {
  const total = subTotal.value - discountSale.value;
  return total > 0 ? total : 0;
});
const repair = ref({
  customer_id: null,
  customer_name: "",
  ma_khach_hang: "",
  phone: "",
  device_name: "",
  issue_description: "",
  cost: 0,
  warranty_period: "",
});

const submitOrder = async () => {
  const customerID =
    tab.value === "sale" ? sale.value.customer_id : repair.value.customer_id;
  if (!customerID) {
    toast.error("Vui lòng chọn khách hàng");
    return;
  }
  loading.value = true;
  try {
    const payload =
      tab.value === "sale"
        ? {
            type: "sale",
            ...sale.value,
            discount: discountSale.value,
            total: totalSale.value,
          }
        : { type: "repair", ...repair.value };
    await adminApi.createInvoice(payload);
    toast.success("Tạo đơn hàng thành công");
    emit("created");
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};
const handleInput = () => {
  activeIndex.value = -1;
};
const handleInputProduct = () => {
  activeIndex.value = -1;
};
const searchCustomers = () => {
  clearTimeout(timeout);
  timeout = setTimeout(async () => {
    if (!keyword.value) {
      customers.value = [];
      return;
    }
    if (cache.has(keyword.value)) {
      customers.value = cache.get(keyword.value);
      showDropdownCustomer.value = true;
      return;
    }
    loading.value = true;

    try {
      const response = await adminApi.getCustomers({
        search: keyword.value,
        per_page: 20,
      });
      customers.value = response.data.data.data || response.data;
      cache.set(keyword.value, customers.value);
      showDropdownCustomer.value = true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Lỗi khi tìm kiếm khách hàng";
      toast.error(errorMessage);
    } finally {
      loading.value = false;
    }
  }, 300);
};

const selectCustomer = (customer) => {
  sale.value.customer_id = customer.id;
  sale.value.customer_name = customer.ten_khach_hang;
  sale.value.ma_khach_hang = customer.ma_khach_hang;
  sale.value.phone = customer.dien_thoai;

  repair.value.customer_id = customer.id;
  repair.value.customer_name = customer.ten_khach_hang;
  repair.value.ma_khach_hang = customer.ma_khach_hang;
  repair.value.phone = customer.dien_thoai;

  keyword.value = `${customer.ten_khach_hang} - ${customer.dien_thoai}`;
  showDropdownCustomer.value = false;
};

const clearCustomerSelection = () => {
  sale.value.customer_id = null;
  sale.value.customer_name = "";
  repair.value.customer_id = null;
  repair.value.customer_name = "";
  keyword.value = "";
};

const createCustomer = async () => {
  toast.info(`Tạo khách hàng mới: ${keyword.value}`);
};

const searchProducts = () => {
  if (loading.value || !productInput.value.trim()) return;
  clearTimeout(timeout);
  timeout = setTimeout(async () => {
    if (!productInput.value) {
      products.value = [];
      return;
    }
    if (cache.has(productInput.value)) {
      products.value = cache.get(productInput.value);
      showDropdownProduct.value = true;
      return;
    }
    loading.value = true;

    try {
      const response = await productApi.searchProductStillInStock({
        search: productInput.value,
        per_page: 10,
      });
      products.value = response.data.data.data || response.data;
      cache.set(productInput.value, products.value);
      showDropdownProduct.value = true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Lỗi khi tìm kiếm sản phẩm";
      toast.error(errorMessage);
    } finally {
      loading.value = false;
    }
  }, 300);
};

const selectProduct = (product) => {
  sale.value.items.push({
    product_id: product.id,
    name: product.ten_hang,
    quantity: 1,
    price: product.gia_ban,
    warranty_period: product.bao_hanh,
    serial_imei: product.serial_imei,
  });
  productInput.value = "";
  showDropdownProduct.value = false;
};

const clearProductSelection = () => {
  productInput.value = "";
  showDropdownProduct.value = false;
};

const toggleDiscount = () => {
  showDiscountInput.value = !showDiscountInput.value;
};
// const handleSaveDiscount = ()=>{
//   showDiscountInput.value = false;
// };
</script>
<style scoped>
.form-group {
  margin-bottom: 15px;
}
.customer-search {
  position: relative;
}

.customer-search input {
  width: 100%;
  padding: 8px;
  padding-right: 30px;
}
.clear-btn {
  position: absolute;
  top: 15%;
  right: 10px;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.product-search .clear-btn {
  top: 47%;
  right: 40px;
}

.clear-btn:hover {
  color: #4b5563; /* Màu đậm hơn khi hover */
}
.loader-icon {
  /* position: absolute; */
  position: relative;
  transform: translateY(-50%);
  color: #667eea;
  padding: 10px;
}

.dropdown-customer {
  position: absolute;
  width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}
.dropdown-product {
  top: 100%;
  position: relative;
  width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}
.dropdown-item span {
  font-size: 0.85em;
  color: #666;
}
.dropdown-item strong {
  overflow: hidden;
}
span {
  font-size: 0.85em;
  color: #666;
}

.dropdown-item {
  padding: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.dropdown-item:hover {
  background: #f5f5f5;
}
.dropdown-item.active {
  background: #42b983;
  color: #fff;
}

.dropdown-item.create {
  color: #007bff;
  font-weight: bold;
}
.tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
}

.tabs button {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.tabs button.active {
  border-bottom: 2px solid #42b983;
  font-weight: bold;
}

.discount,
.sub-total,
.total {
  text-align: right;
  margin-top: 10px;
  font-size: 18px;
}

.discount-wrapper {
  position: relative;
  /* display: inline-block; */
}

.discount {
  cursor: pointer;
}

.discount-popup {
  position: absolute;
  top: 30px;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.discount-popup input {
  width: 150px;
  padding: 6px;
}
</style>
